import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaListAlt,
  FaPlus,
  FaCommentDots,
  FaUser,
  FaGem,
  FaThLarge,
} from "react-icons/fa";
import "./RetailerLayout.scss";

const RetailerLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="vaidya-layout-wrapper">
      {/* --- SIDEBAR / BOTTOM NAV --- */}
      <nav className="vaidya-layout-nav">
        {/* Brand Area */}
        <div className="vaidya-layout-brand">
          <div className="vaidya-layout-icon-wrap">
            <FaGem className="vaidya-layout-brand-icon" />
          </div>
          <span className="vaidya-layout-brand-text">Vaidya Retail</span>
        </div>

        {/* Desktop Primary Action */}
        <div className="vaidya-layout-desktop-action">
          <button
            className="vaidya-layout-btn-new-order"
            onClick={() => navigate("/retailer/new-order")}
          >
            <FaPlus className="vaidya-layout-btn-icon" />
            <span className="vaidya-layout-btn-text">New Order</span>
          </button>
        </div>

        {/* Navigation Links */}
        <div className="vaidya-layout-links">
          <NavLink
            to="/retailer"
            end
            className={({ isActive }) =>
              `vaidya-layout-item ${isActive ? "active" : ""}`
            }
          >
            <FaHome className="vaidya-layout-nav-icon" />
            <span className="vaidya-layout-nav-label">Home</span>
          </NavLink>

          <NavLink
            to="/retailer/catalogue"
            className={({ isActive }) =>
              `vaidya-layout-item ${isActive ? "active" : ""}`
            }
          >
            <FaThLarge className="vaidya-layout-nav-icon" />
            <span className="vaidya-layout-nav-label">Catalogue</span>
          </NavLink>

          <NavLink
            to="/retailer/retailers-orders"
            className={({ isActive }) =>
              `vaidya-layout-item ${isActive ? "active" : ""}`
            }
          >
            <FaListAlt className="vaidya-layout-nav-icon" />
            <span className="vaidya-layout-nav-label">Orders</span>
          </NavLink>

          <NavLink
            to="/retailer/messages"
            className={({ isActive }) =>
              `vaidya-layout-item ${isActive ? "active" : ""}`
            }
          >
            <div className="vaidya-layout-badge-wrap">
              <FaCommentDots className="vaidya-layout-nav-icon" />
              <span className="vaidya-layout-badge">3</span>
            </div>
            <span className="vaidya-layout-nav-label">Chat</span>
          </NavLink>

          <NavLink
            to="/retailer/profile"
            className={({ isActive }) =>
              `vaidya-layout-item ${isActive ? "active" : ""}`
            }
          >
            <FaUser className="vaidya-layout-nav-icon" />
            <span className="vaidya-layout-nav-label">Profile</span>
          </NavLink>
        </div>
      </nav>

      {/* --- MOBILE FLOATING ACTION BUTTON --- */}
      <button
        className="vaidya-layout-mobile-fab"
        onClick={() => navigate("/retailer/new-order")}
        aria-label="Create New Order"
      >
        <FaPlus />
      </button>

      {/* --- 80% MAIN CONTENT AREA --- */}
      <main className="vaidya-layout-main">
        <div className="vaidya-layout-limiter">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default RetailerLayout;
